import { GlobalBus } from '@services/bus'

const defaultButton = {
  text: '',
  close: true,
  timeout: 4000,
  status: 'default',
}

export const ADD_QUEUE_BIG_SNACK = (state, payload) => {
  if (payload.text) {
    state.queueBigSnackbar.push({ ...defaultButton, ...payload })
    GlobalBus.$emit('show-big-snackbar')
  }
}

export const REMOVE_FIRST_ITEM = (state, payload) => {
  const first = state.queueBigSnackbar[0]

  // comparar com o item recebido pra saber se está removendo corretamente?
  if (first) {
    state.queueBigSnackbar.splice(0, 1)
  }
}
export const SET_DISCLAIMER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const dict = payload.reduce((all, next) => {
      all[next.codigo] = next.texto
      return all
    }, {})
    const dictImg = payload.reduce((all, next) => {
      all[next.codigo] = next.img_link
      return all
    }, {})
    state.disclaimer.data = { ...dict }
    state.disclaimer.dataImg = { ...dictImg }
    state.disclaimer.lastUpdate = new Date()
  }
}
export const ADD_DISCLAIMER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.disclaimer.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.disclaimer.data.push(data)
      }
    })
  }
}
export const SET_DISCLAIMER_LOADING = (state, payload) => {
  state.disclaimer.loading = payload
}
export const SET_OFFICE_PARAMETERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.officeParameters.data = payload
    state.officeParameters.lastUpdate = new Date()
  }
}
export const ADD_OFFICE_PARAMETERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.officeParameters.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.officeParameters.data.push(data)
      }
    })
  }
}
export const SET_OFFICE_PARAMETERS_LOADING = (state, payload) => {
  state.officeParameters.loading = payload
}

export const SET_PROFISSIONAIS_PERMISSAO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.profissionaisPermissao.data = payload
    state.profissionaisPermissao.lastUpdate = new Date()
  }
}
export const ADD_PROFISSIONAIS_PERMISSAO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.profissionaisPermissao.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.profissionaisPermissao.data.push(data)
      }
    })
  }
}
export const SET_PROFISSIONAIS_PERMISSAO_LOADING = (state, payload) => {
  state.profissionaisPermissao.loading = payload
}
export const SET_INTERNAL_USERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.internalUsers.data = payload
    state.internalUsers.lastUpdate = new Date()
  }
}
export const ADD_INTERNAL_USERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.internalUsers.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.internalUsers.data.push(data)
      }
    })
  }
}
export const SET_INTERNAL_USERS_LOADING = (state, payload) => {
  state.internalUsers.loading = payload
}

export const SET_PREVIOUS_PAGE = (state, payload) => {
  state.previousPage = payload
}
export const SET_FULL_DATA_CLIENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.fullDataClient.data = payload
    state.fullDataClient.lastUpdate = new Date()
  }
}
export const ADD_FULL_DATA_CLIENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.fullDataClient.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.fullDataClient.data.push(data)
      }
    })
  }
}
export const SET_FULL_DATA_CLIENT_LOADING = (state, payload) => {
  state.fullDataClient.loading = payload
}
